import { environment } from 'src/environments/environment';
import { ContextData } from 'src/app/data/context.data';

export class TemplateLogoData {

  private _data:any;
  private _base64:ArrayBuffer;

  constructor(data:any = null) {
    if (data) {
      this.setData(data);
    }
  }

  /**
	 * data
	 */
  public setData(value: any):Promise<boolean> {
    this._data = value;

    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onloadend = () => {
          this._base64 = reader.result as ArrayBuffer;
          resolve(true);
        }
        reader.readAsDataURL(xhr.response);
      };


      xhr.open('GET', environment.LOGO.LABEL);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  public get x():number {
    return this._data.x;
  }

  public get y():number {
    return this._data.y;
  }

  public get width():number {
    return this._data.width;
  }

  public get height():number {
    return this._data.height;
  }

  public get rotation():number {
    return this._data.rotation;
  }

  public get base64():ArrayBuffer {
    return this._base64;
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    this._data = null;
    this._base64 = null;
  }

}
